import { suffix } from '../wrappers/tag-suffix';
import { LoggerLevels } from '../wrappers';
export const transformTag = (tag) => `${tag}${suffix}`;
export const camelToHyphenated = (string) => string.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
export const idsLogger = (msg, level = LoggerLevels.Log) => {
    // eslint-disable-next-line
    console[level]('%c IDS ', 'background: #21F5A8; color: #3A1C46; font-weight:bold;', msg);
};
//# sourceMappingURL=helpers.js.map